import React from "react";
import { PinSvg } from "./PinSvg";

export const GoogleMapShowPinForMapList = () =>
  <div className="google-map-pin-for-list">
    <PinSvg width={20} height={32} empty fillColor="var(--map-show-purple)" />
  </div>

export const GoogleMapVenuePinForMapList = () =>
  <div className="google-map-pin-for-list">
    <PinSvg width={20} height={32} empty fillColor="var(--map-venue-blue)" />
  </div>

export const GoogleMapAirportPinForMapList = () =>
  <div className="google-map-pin-for-list">
    <PinSvg width={20} height={32} empty fillColor="var(--map-airport-green)" />
  </div>